export const SHIRT_SIZES = [
  { label: 'XS', code: 1 },
  { label: 'S', code: 2 },
  { label: 'M', code: 3 },
  { label: 'L', code: 4 },
  { label: 'XL', code: 5 },
];
